<template>
    <div class="flex flex-col gap-4">
        <FlashcardListItem
            v-for="card in cards"
            :key="card.id"
            :card="card"
            @edit="$emit('edit', $event)"
            @delete="$emit('delete', $event)"
        />
    </div>
</template>

<script>
'use strict';

import FlashcardListItem from './FlashcardListItem.vue';

export default {
    name: 'FlashcardList',
    components: { FlashcardListItem },
    props: {
        cards: { type: Array, required: true },
    },
};
</script>
